import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Spinner, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../../extras/icons';
import ButtonSpinner from '../../../layout/ButtonSpinner';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveNotificationsAction } from '../../../../actions/notificationsActions';
import { listNotificationTypesAction } from '../../../../actions/notificationTypesActions';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import destinationTypes, { PROSECUTION, PUBLIC_DEFENSE, PARTICULAR_DEFENSE, ACCUSED, INTERVEENING, JUDGE, NEW_DESTINATION, OPERATOR, VICTIM } from '../../../../data/destinationTypes';
import DestinationService from '../../../../services/DestinationService';
import { NOTI_SISTEMA } from '../../../../data/notificationTypes';
import { ErrorMessage } from '../../../extras/toastMessages';
import { MSG_ERROR_NOTIFICATION_CREATE, MSG_ERROR_NOTIFICATION_EMAIL } from '../../../../constants/messages'
//Función principal
const NotificationForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los refs
    const refTipo = useRef();
    //Datos iniciales
    const initialData = {
        fecha: '',
        hora: '',
        tipoDestino: '',
        tipo: '',
        destino: '',
        observacion: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const notificationsLoading = useSelector( state => state.notifications.loadingSave );
    const errorSave = useSelector( state => state.notifications.errorSave );
    const notificationTypes = useSelector( state => state.notificationTypes.notificationTypes );
    //Inicializo el state local
    const [ notification, setNotification ] = useState(initialData);
    const [ destinationType, setDestinationType ] = useState('');
    const [ destinations, setDestinations ] = useState([]);
    //Manejo de cambios
    const handleChangeDestination = e => {
        setDestinationType(e.target.value);
        //Si no es nueva, busco
        if(parseInt(e.target.value) !== NEW_DESTINATION){
            //Busco los nuevos destinos
            setDestinations(DestinationService.getDestinations(parseInt(e.target.value), audience));
        }
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...notification
        }
        //Agrego los nuevos valores
        data = {
            destino: values.destino,
            email: values.email,
            fecha: parseInt(values.tipo) === NOTI_SISTEMA ? null : `${values.fecha}T${values.hora}:00.000-03:00`,
            observacion: values.observacion,
            tipo_destinatario: destinationType,
            tipo: {
                id: values.tipo
            },
            audiencia: {
                id: audience.id
            }
        }
        //Me fijo que tipo de notificación es
        if(parseInt(values.tipo) !== NEW_DESTINATION){
            //Busco el destinatario elegido
            const destination = destinations.find(d => d.descripcion === data.destino);
            //Me fijo si encontró algo
            if(!destination){
                //Mando error
                ErrorMessage(MSG_ERROR_NOTIFICATION_CREATE);
                //Corto
                return false;
            }
            //Me fijo si es notificación por sistema
            if(parseInt(values.tipo) === NOTI_SISTEMA){
                //Debo validar el email
                if(typeof destination.email === "undefined" || destination.email.trim() === ''){
                    //Mando error
                    ErrorMessage(MSG_ERROR_NOTIFICATION_EMAIL);
                    //Corto
                    return false;
                }
            }
            
            //Seteo los datos
            data = {
                ...data,
                destino: destination.descripcion,
                email: destination.email
            }
        }
        //Es creación
        dispatch( saveNotificationsAction(data, handleCloseForm) );
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si hay datos de tipos
        if(!notificationTypes){
            dispatch( listNotificationTypesAction() );
        }
        //Pongo el foco en el primer campo
        refTipo.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setNotification(initialData);
        //Cierro
        handleClose();
        //Refresco la página
        setTimeout(()=>{
            window.location.reload();
        },100)
        
    }
    //Esquema de validación
    const validationSchema = yup.object({
        fecha: yup.date().when('tipo', {
            is: NOTI_SISTEMA,
            then: yup.date().nullable(),
            otherwise: yup.date().required()
        }),
        hora: yup.string().when('tipo', {
            is: NOTI_SISTEMA,
            then: yup.string().nullable(),
            otherwise: yup.string().required()
        }),
        tipo: yup.number().required(),
        destino: yup.string().required(),
        observacion: yup.string().nullable()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Notificación&nbsp;
                    <small><strong>Nuevo Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...notification }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-6">
                                    <label htmlFor="grupo">Tipo</label>
                                    <Form.Control
                                        as="select"
                                        id="tipo"
                                        className="form-control"  
                                        name="tipo" 
                                        value={ values.tipo }
                                        ref={refTipo}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo}
                                        disabled={ notificationsLoading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {
                                            notificationTypes ? (
                                                notificationTypes.map(notificationType => (
                                                    <option value={ notificationType.id } key={`nt${notificationType.id}`}>
                                                        { notificationType.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="fecha">Fecha</label>
                                    <Form.Control
                                        id="fecha"
                                        className="form-control" 
                                        autoFocus 
                                        name="fecha" 
                                        type="date" 
                                        value={ values.fecha }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fecha}
                                        disabled={ notificationsLoading || parseInt(values.tipo) === NOTI_SISTEMA }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="hora">Hora</label>
                                    <Form.Control
                                        id="hora"
                                        className="form-control"  
                                        name="hora" 
                                        type="time" 
                                        value={ values.hora }
                                        onChange={handleChange}
                                        isInvalid={!!errors.hora}
                                        disabled={ notificationsLoading || parseInt(values.tipo) === NOTI_SISTEMA }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.hora }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="tipoDestino">Tipo Destino</label>
                                    <Form.Control
                                        as="select"
                                        id="tipoDestino"
                                        className="form-control"  
                                        name="tipoDestino" 
                                        value={ destinationType }
                                        onChange={handleChangeDestination}
                                        isInvalid={!!errors.tipoDestino}
                                        disabled={ notificationsLoading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {
                                            destinationTypes.map(dType => (
                                                <option value={dType.id} key={`dt${dType.id}`}>
                                                    { dType.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipoDestino }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                {
                                    parseInt(destinationType) === NEW_DESTINATION ? (
                                        <React.Fragment>
                                            <Form.Group className="col-md-6">
                                                <label htmlFor="destino">Destino</label>
                                                <Form.Control
                                                    id="destino"
                                                    className="form-control"  
                                                    name="destino" 
                                                    type="text" 
                                                    value={ values.destino }
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.destino}
                                                    disabled={ notificationsLoading }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    { errors.destino }
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="col-md-12">
                                                <label htmlFor="email">Email</label>
                                                <Form.Control
                                                    id="email"
                                                    className="form-control"  
                                                    name="email" 
                                                    type="text" 
                                                    value={ values.email }
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.email}
                                                    disabled={ notificationsLoading }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    { errors.email }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </React.Fragment>
                                    ) : (
                                        <Form.Group className="col-md-6">
                                            <label htmlFor="destino">Destinatario</label>
                                            <Form.Control
                                                as="select"
                                                id="destino"
                                                className="form-control"  
                                                name="destino" 
                                                value={ values.destino }
                                                onChange={handleChange}
                                                isInvalid={!!errors.destino}
                                                disabled={ notificationsLoading }
                                            >
                                                <option value="">Seleccione...</option>
                                                {
                                                    destinations.map((destination, index) => (
                                                        <option value={ destination.descripcion } key={`nd${index}`}>
                                                            { destination.descripcion }
                                                        </option>
                                                    ))
                                                }
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">
                                                { errors.destino }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    )
                                }
                                <Form.Group className="col-md-12">
                                    <label htmlFor="observacion">Observacion</label>
                                    <Form.Control
                                        id="observacion"
                                        className="form-control" 
                                        name="observacion" 
                                        type="observacion" 
                                        value={ values.observacion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.observacion}
                                        disabled={ notificationsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                notificationsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ notificationsLoading }>
                                        <ICON_SAVE /> <strong>GUARDAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ notificationsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default NotificationForm;
